import { RouterModule, Routes } from '@angular/router';
import { BrowserNotSupportedComponent } from '@core/components/browser-not-supported/browser-not-supported.component';
import { LoginComponent } from '@core/components/login/login.component';
import { LogoutComponent } from '@core/components/logout/logout.component';
import { ForbiddenComponent } from '@core/components/forbidden/forbidden.component';
import { AdminGuard } from '@core/guards/admin.guard';
import { NgModule } from '@angular/core';
import { NoConnectionComponent } from '@core/components/no-connection/no-connection.component';
import { NotfoundComponent } from '@core/components/notfound/notfound.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

const appRoutes: Routes = [
	{
		path: '',
		component: MsalRedirectComponent
	},
	{
		path: 'login',
		component: LoginComponent,
	},
	{
		path: 'logout',
		component: LogoutComponent
	},
	{
		path: 'projects',
		loadChildren: () => import('./modules/user/project/project.module').then(m => m.ProjectModule),
		canActivate: [MsalGuard]
	},
	{
		path: 'reports',
		loadChildren: () => import('./modules/user/report/report.module').then(m => m.ReportModule),
		canActivate: [MsalGuard]
	},
	{
		path: 'tasks',
		loadChildren: () => import('./modules/user/task/task.module').then(m => m.TaskModule),
		canActivate: [MsalGuard]
	},
	{
		path: 'browser-not-supported',
		component: BrowserNotSupportedComponent
	},
	{
		path: 'forbidden',
		component: ForbiddenComponent
	},
	{
		path: 'no-connection',
		component: NoConnectionComponent
	},
	{
		path: '',
		redirectTo: 'projects',
		pathMatch: 'full'
	},
	{
		path: '**',
		component: NotfoundComponent,
		pathMatch: 'full'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' })],
	exports: [RouterModule],
	providers: []
})
export class AppRoutingModule { }